var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac-empty",attrs:{"data-test":"ac-empty"}},[_c('span',{staticClass:"ac-empty-mark"},[_c('AcIcon',{attrs:{"name":_vm.icon,"size":22}})],1),_c('div',{staticClass:"ac-empty-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ac-empty-body"},[_vm._v(_vm._s(_vm.body))])])
}
var staticRenderFns = []

export { render, staticRenderFns }